export function monthlyHourlyRate(monthlySalary, settings = {}) {
  const weeklyHours = Number(settings.weeklyHours ?? settings.payroll?.weeklyHours ?? 40);
  const divisor = Number(settings.monthlyDivisor ?? settings.payroll?.monthlyDivisor ?? 0);
  const amount = Math.max(0, Number(monthlySalary) || 0);
  if (divisor > 0) return amount / divisor;
  return weeklyHours > 0 ? (amount * 12) / (weeklyHours * 52) : 0;
}

// Hourly workers receive the base overtime hour in their worked-hours pay.
// Monthly workers need the overtime base hour as well as the configured premium.
export function overtimePay(overtime, payType, amount, settings = {}) {
  if (payType === "monthly") {
    const paidHours = Number(overtime.premiumHours || 0) + Number(overtime.premiumValue || 0);
    return paidHours * monthlyHourlyRate(amount, settings);
  }
  return Number(overtime.premiumValue || 0) * Number(amount || 0);
}
